import countryCodes from '@/features/user/store/records/countryCodes.json'

export const clearPhoneNumber = num => num?.replace(/[()-]/g, '') || ''

// Создаем Map для быстрого поиска кодов стран
const createCountryCodesMap = () => {
  const map = new Map()
  // Сортируем по длине кода убывания для longest match
  const sortedCodes = [...countryCodes].sort((a, b) => b.value.length - a.value.length)

  sortedCodes.forEach(country => {
    map.set(country.value, country)
  })

  return map
}

// Кешированная карта кодов стран
const countryCodesMap = createCountryCodesMap()

/**
 * Форматирует телефонный номер по маске соответствующей страны
 * @param {string} phone - телефонный номер (например, "+79967925001")
 * @returns {string} - отформатированный номер или оригинальная строка при ошибке
 */
export const formatPhoneNumber = phone => {
  // Проверяем базовые условия
  if (!phone || typeof phone !== 'string') return phone || ''

  // Если номер не начинается с +, возвращаем как есть
  if (!phone.startsWith('+')) return phone

  // Находим подходящий код страны (longest match)
  const matchedCountry = Array.from(countryCodesMap.entries()).find(([code]) => phone.startsWith(code))?.[1]

  // Если код страны не найден, возвращаем оригинал
  if (!matchedCountry) return phone

  // Извлекаем номер без кода страны
  const phoneWithoutCode = phone.slice(matchedCountry.value.length)

  // Убираем все нецифровые символы из номера
  const digits = phoneWithoutCode.replace(/\D/g, '')

  // Проверяем, достаточно ли цифр для полного форматирования
  const requiredDigits = (matchedCountry.mask.match(/#/g) || []).length
  if (digits.length < requiredDigits) {
    // Номер неполный, возвращаем как есть
    return phone
  }

  // Применяем маску
  let formattedNumber = matchedCountry.mask
  let digitIndex = 0

  // Заменяем # на цифры номера
  formattedNumber = formattedNumber.replace(/#/g, () => {
    if (digitIndex < digits.length) {
      return digits[digitIndex++]
    }
    return '#' // Если цифр не хватает, оставляем #
  })

  // Возвращаем код страны + отформатированный номер
  return `${matchedCountry.value} ${formattedNumber}`
}
